// extracted by mini-css-extract-plugin
export var label = "_a0-5";
export var slideContainer = "_a0-0";
export var slider = "_a0-1";
export var sliderLg = "_a0-4";
export var sliderMd = "_a0-3";
export var sliderSm = "_a0-2";